import React, { useState } from 'react'
import { Form, Input, Button, Checkbox, notification } from 'antd'
import loginImage from '../pages/6310507.jpg' // Import the image file
import './AluminiLogin.css'
import axios from 'axios'
import { Link } from 'react-router-dom' // Import useHistory
import { useNavigate } from 'react-router-dom'
import { AluminiSignUpApi } from './../../ApiFile'
import { Modal } from 'antd'
import { toast } from 'react-toastify'

const AluminiSignup = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  // const onFinish = async (values) => {
  //   setLoading(true)
  //   try {
  //     const response = await axios.post(AluminiSignUpApi, values)
  //     navigate('/AluminiLogin')
  //   } catch (error) {
  //     console.error('Error occurred:', error)
  //   }

  //   setTimeout(() => {
  //     setLoading(false)
  //     // Validate password and confirm password
  //     if (values.password !== values.confirm_password) {
  //       notification.error({
  //         message: 'Signup Failed',
  //         description: 'Password and confirm password do not match.',
  //       })
  //     } else {
  //       // Simulate successful signup
  //       notification.success({
  //         message: 'Signup Successful',
  //         description: 'Welcome, your account has been created !',
  //       })
  //     }
  //   }, 1000)
  // }

 // Make sure Modal is imported

const onFinish = async (values) => {
  setLoading(true)

  // Check if password and confirm password match before API call
  if (values.password !== values.confirm_password) {
    setLoading(false)
    Modal.error({
      title: 'Signup Failed',
      content: 'Password and confirm password do not match.',
    })
    return
  }

  try {
    const response = await axios.post(AluminiSignUpApi, values)
      if (response.data.message == "SAVED") {
        // Show modal centered and navigate on OK click
          Modal.success({
            title: 'Signup Successful',
            content: 'Welcome, your account has been created! Please login again and fill the detail form.',
            centered: true,
            onOk: () => navigate('/AluminiLogin'), // Navigate after OK is clicked
          })
      }
      else if(response.data.message == "ALREDYEXIST"){
          toast.warn("Email already exist! Try with different email")
      }
   
  } catch (error) {
    console.error('Error occurred:', error)
    Modal.error({
      title: 'Signup Failed',
      content: 'An error occurred while signing up.',
      centered: true,
    })
  } finally {
    setLoading(false)
  }
}




  return (
    <div className="login-page">
      <div className="login-box py-0">
        <div className="illustration-wrapper">
          <img src={loginImage} alt="Login" /> {/* Use the imported image */}
        </div>

        <Form
          name="login-form"
           className="login-form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <p className="form-title" style={{ marginTop: '50px' }}>
            Alumni Sign Up
          </p>
          <p>Sign up for account</p>
          <Form.Item
            name="fname"
            rules={[
              { required: true, message: 'Please input your First Name!' },
            ]}
          >
            <Input placeholder="First Name" />
          </Form.Item>

          <Form.Item
            name="mname"
            rules={[
              { required: true, message: 'Please input your Middle Name!' },
            ]}
          >
            <Input placeholder="Middle Name" />
          </Form.Item>

          <Form.Item
            name="lname"
            rules={[
              { required: true, message: 'Please input your Last Name!' },
            ]}
          >
            <Input placeholder="Last Name" />
          </Form.Item>

          <Form.Item
            name="email_id"
            rules={[
              { required: true, message: 'Please input your Email ID!' },
              { type: 'email', message: 'Please enter a valid email address!' },
            ]}
          >
            <Input placeholder="Email ID" />
          </Form.Item>

          <label style={{fontWeight:"normal"}}>Create Password</label>
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password placeholder="Create Password" />
          </Form.Item>

          <label style={{fontWeight:"normal"}}>Confirm Password</label>
          <Form.Item
            name="confirm_password"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Please confirm your password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(
                    new Error('The two passwords do not match!'),
                  )
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm Password" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="signup-form-button"
              loading={loading}
            >
              SIGN UP
            </Button>
          </Form.Item>
          <Form.Item>
            <p>
              Already have an account? <Link to="/AluminiLogin">Log in</Link>
            </p>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default AluminiSignup
